// sourceSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { fetchPDF } from './pdfViewslice';

const initialState = {
  selectedSources: [],
  currentPdf: {
    filename: null,
    page: null,
    blob: null,
  },
  loading: false,
  error: null
};

const sourceSlice = createSlice({
  name: 'source',
  initialState,
  reducers: {
    addSource: (state, action) => {
      const { filename, page } = action.payload;
      state.loading = true;
      state.currentPdf.filename = filename;
      state.currentPdf.page = page;
      state.currentPdf.blob = null;
      
      const sourceExists = state.selectedSources.some(
        source => source.filename === filename && source.page === page
      );
      
      if (!sourceExists) {
        state.selectedSources.push({ filename, page });
      }
    },
    removeSource: (state, action) => {
      const { filename, page } = action.payload;
      state.selectedSources = state.selectedSources.filter(
        source => !(source.filename === filename && source.page === page)
      );
    },
    clearSources: (state) => {
      state.selectedSources = [];
      state.currentPdf = {
        filename: null,
        page: null,
        blob: null,
      };
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPDF.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPDF.fulfilled, (state, action) => {
        state.loading = false;
        state.currentPdf.blob = action.payload;
      })
      .addCase(fetchPDF.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { addSource, removeSource, clearSources } = sourceSlice.actions;
export default sourceSlice.reducer;